import { getBootstrap } from '@/config/bootstrap';

export class PaymentsConnectUrlError extends Error {
  constructor() {
    super('Unexpected payments connect URL');
    this.name = 'PaymentsConnectUrlError';
  }
}

/**
 * `payOrigin` is a platform singleton read verbatim from the resolved
 * bootstrap (DNKADM-0274) — never derived from this app's host. A null
 * `payOrigin` (the tenant has no pay configuration) disallows the connect
 * return rather than falling back to any computed host.
 */
export function validatePaymentsConnectUrl(connectUrl: string): string {
  const { payOrigin } = getBootstrap();
  if (!payOrigin) {
    throw new PaymentsConnectUrlError();
  }

  let parsedUrl: URL;
  let allowedOrigin: string;
  try {
    parsedUrl = new URL(connectUrl);
    allowedOrigin = new URL(payOrigin).origin;
  } catch {
    throw new PaymentsConnectUrlError();
  }

  if (parsedUrl.protocol !== 'https:' || parsedUrl.origin !== allowedOrigin) {
    throw new PaymentsConnectUrlError();
  }

  return parsedUrl.href;
}
